module.exports = __webpack_public_path__ + "img/pickup-address-icon.2b671853.png";